import { CreateDrainRequestSchema } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/drain_mutation_pb';
import { create } from '@bufbuild/protobuf';
import { TFunction } from 'i18next';
import { PipeDuotoneIcon, PipeIcon } from '~/shared/components/Icons/Icons';

type DrainParams = {
  pressurePipe: boolean;
  fromReservoirName: string;
};

export class CreateDrainModel {
  static getCreateDrainDetails(params: DrainParams, t: TFunction) {
    return {
      request: create(CreateDrainRequestSchema, params),
      label: CreateDrainModel.getLabel(params.pressurePipe, t),
      icon: CreateDrainModel.getIcon(params.pressurePipe),
    };
  }

  private static getIcon(pressurePipe: boolean) {
    if (pressurePipe) {
      return <PipeDuotoneIcon />;
    }
    return <PipeIcon />;
  }

  static getErrorMessage(pressurePipe: boolean, t: TFunction) {
    if (pressurePipe) {
      return t('systemDesign.pressurePipe.create.error');
    }
    return t('systemDesign.drain.create.error');
  }

  private static getLabel(pressurePipe: boolean, t: TFunction) {
    if (pressurePipe) {
      return t('systemDesign.pressurePipe.create.button');
    }
    return t('systemDesign.drain.create.button');
  }
}
